import React from 'react';
import users from '../../../constants/users';
import FormBuyerIndividual from './FormBuyerIndividual';
import FormBuyerCompany from './FormBuyerCompany';
import FormSellerIndividual from './FormSellerIndividual';
import FormSellerCompany from './FormSellerCompany';
import FormCharity from './FormCharity';
import FormAffiliate from './FormAffiliate';

const Forms = ({ type, onFormSubmit, id }) => {
    switch (type) {
        case users.BUYER_INDIVIDUAL.key:
            return <FormBuyerIndividual onFormSubmit={onFormSubmit} id={id} userType={users.BUYER_INDIVIDUAL.key} />;
        case users.BUYER_CORPORATE_COMPANIES.key:
            return <FormBuyerCompany onFormSubmit={onFormSubmit} id={id} userType={users.BUYER_CORPORATE_COMPANIES.key} />;
        case users.SELLER_BUSINESSES.key:
            return <FormSellerIndividual onFormSubmit={onFormSubmit} id={id} userType={users.SELLER_BUSINESSES.key} />;
        case users.SELLER_CORPORATE_COMPANIES.key:
            return <FormSellerCompany onFormSubmit={onFormSubmit} id={id} userType={users.SELLER_CORPORATE_COMPANIES.key} />;
        case users.CHARITY.key:
            return <FormCharity onFormSubmit={onFormSubmit} id={id} userType={users.CHARITY.key} />;
        case users.AFFILIATE.key:
            return <FormAffiliate onFormSubmit={onFormSubmit} id={id} userType={users.AFFILIATE.key} />;
        default:
            return <></>;
    }
};

export default Forms;